import { forwardRef, LabelHTMLAttributes } from 'react';
import clsx from 'clsx';

export const Label = forwardRef<
  HTMLLabelElement,
  LabelHTMLAttributes<HTMLLabelElement> & { className?: string }
>(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={clsx('block text-sm font-medium text-foreground', className)}
    {...props}
  />
));
Label.displayName = 'Label';
